module.exports = __webpack_public_path__ + "static/media/investigative_med.e5d54360.jpg";